import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import s from './ScrollList.less'

const ScrollList = ({ data, render, listRef, listItemsRefs, listClassName, listItemClassName, selectedItem }) => (
  <ul ref={listRef} className={listClassName}>
    {data.map((dataItem, idx) => {
      const isSelected = selectedItem && selectedItem.id === dataItem.id
      return (
        <li
          ref={listItemsRefs?.[idx]}
          key={`${dataItem.id}-${idx}`}
          className={classnames(listItemClassName, selectedItem && !isSelected && s.itemInactive)}
        >
          {render(dataItem)}
        </li>
      )
    })}
  </ul>
)

ScrollList.propTypes = {
  data: PropTypes.array.isRequired,
  render: PropTypes.func.isRequired,
  listClassName: PropTypes.string,
  listItemClassName: PropTypes.string,
  listRef: PropTypes.any,
  listItemsRefs: PropTypes.array,
  selectedItem: PropTypes.shape({
    id: PropTypes.string
  })
}

export default ScrollList
